import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ClassiUtentiService {

    static getClassiUtentiByParams = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/find`;
            ApiService.postRudeRequest(resolve, reject, url, data)
        });
      };
    static getClassiUtentiByIdClasse = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/utenti_by_id_classe`;
            ApiService.postRequest(resolve, reject, url, data)
        });
      };

    static getClassiUtenteByToken = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/findAssignedByToken`;
            ApiService.getRequest(resolve, reject, url)
        });
      };
      
    static getClassiUtenteByUserId = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/find-assigned-by-user-id`;
            ApiService.postRequest(resolve, reject, url, data)
        });
      };

      static createClassiUtenti = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static deleteClassiUtenti = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/delete`;
          ApiService.delete(resolve, reject, url, data)
      });
    }
    
    static deleteClassiUtentiByClasseAndUtente = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/delete_by_classe_and_utente`;
          ApiService.delete(resolve, reject, url, data)
      });
    }

    static updateCondizioni = (data) => {//NEW
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/update-condizioni`;
          ApiService.putRequest(resolve, reject, url, data)
      });
    }

    static getCondizioni = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/get-condizioni`;
          ApiService.postRequest(resolve, reject, url, data)
      });
    }
    
    static updateStatoPagamento = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/update-stato-pagamento`;
          ApiService.putRequest(resolve, reject, url, data)
      });
    }

    static findClassiUtentiByUtente = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/classi-utenti/find-details-by-utente`;
          ApiService.postRequest(resolve, reject, url, data)
      });
    }


}